<template>
    <modal class="interview-modal" ref="modal" @dismiss="$emit('dismiss')">
        <template #header>
            <div class="interview-modal-header">
                <ceo-change-logo class="verified" />
                <h1>{{ interview.title }}</h1>
            </div>
        </template>

        <template>
            <tabbed-view :tabs="tabs" :active.sync="tab" tab-type="light">
                <template #overview>
                    <InterviewModalOverviewTab :interview="boundInterview" />
                </template>
                <template #transcript>
                    <InterviewModalTranscriptTab :interview="boundInterview" />
                </template>
                <template #survey>
                    <SurveyResults :survey="survey" />
                </template>
            </tabbed-view>
        </template>
    </modal>
</template>
<script setup>
import { InterviewService } from '@/services/interviewService'

import InterviewModalOverviewTab from '@/components/executives/Research/InterviewModalOverviewTab'
import InterviewModalTranscriptTab from '@/components/executives/Research/InterviewModalTranscriptTab'
import CeoChangeLogo from '@/components/ceo-change/logo'
import SurveyResults from '@/components/executives/Research/SurveyResults.vue'
import { computed, onMounted, onUnmounted, ref } from 'vue'
import { asyncComputed } from '@/utils/asyncComputed'
import { queryParam } from '@/utils/queryParam'

const props = defineProps({
    interview: {
        type: Object,
        required: true,
    },
})

const interviewId = queryParam('interviewId')
const highlight = queryParam('interview.highlight')
const tab = queryParam('interview.tab', { initial: 'Overview' })

const highlightedInterview = asyncComputed(async () => {
    const q = highlight.value?.trim() ?? ''

    if (q.length > 0) {
        return await InterviewService.highlight(props.interview.id, q)
    }

    return props.interview
}, props.interview)

const survey = asyncComputed(() => InterviewService.getSurvey(props.interview.id), null)

const boundInterview = computed(() => highlightedInterview.value ?? props.interview)

const tabs = computed(() => {
    const tabs = ['Overview', 'Transcript']

    if (survey.value !== null) {
        tabs.push('Survey')
    }

    return tabs
})

onMounted(() => {
    interviewId.value = props.interview.id
})

onUnmounted(() => {
    interviewId.value = null
    tab.value = null
})
</script>

<style>
.interview-modal {
    .modal {
        width: 80%;
        height: 90%;
        padding: 48px;
    }

    .interview-modal-header {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        gap: 16px;

        h1 {
            margin: 0;
        }
    }

    .search-result-highlight {
        background-color: orange;
        color: black;
    }
}
</style>
